// 入库类型code
const inTypeCode = {
  order: 'DD', // 订单入库
  return: 'TH', // 退货入库
  transfer: 'DB', // 调拨入库
  initial: 'QC', // 期初建账
  virtual: 'XN', // 虚拟入库
  other: 'QT', // 其他入库
}
// 出库类型code
const outTypeCode = {
  order: 'DD', // 订单出库
  return: 'TH', // 退供出库
  transfer: 'DB', // 调拨出库
  transferBetween: 'DBIN', // 调拨出库（库内）
  destruction: 'XH', // 销毁出库
  other: 'QT', // 其他出库
}
export const INTYPECODE = inTypeCode;

export const OUTTYPECODE = outTypeCode;

// 入库类型
export const INTYPE = [
  {
    lable: '订单入库',
    value: inTypeCode.order,
  },
  {
    lable: '退货入库',
    value: inTypeCode.return,
  },
  {
    lable: '调拨入库',
    value: inTypeCode.transfer,
  },
  {
    lable: '期初建账',
    value: inTypeCode.initial,
  },
  {
    lable: '虚拟入库',
    value: inTypeCode.virtual,
  },
  {
    lable: '其他入库',
    value: inTypeCode.other,
  },
];

// 出库类型
export const OUTTYPE = [
  {
    lable: '订单出库',
    value: outTypeCode.order,
  },
  {
    lable: '退供出库',
    value: outTypeCode.return,
  },
  {
    lable: '调拨出库',
    value: outTypeCode.transfer,
  },
  {
    lable: '调拨出库（库内）',
    value: outTypeCode.transferBetween,
  },
  {
    lable: '销毁出库',
    value: outTypeCode.destruction,
  },
  {
    lable: '其他出库',
    value: outTypeCode.other,
  },
];

// 订单类型
export const WAREHOUSETYPE = {
  in: 'STORE', // 入库
  out: 'DELIVER', // 出库
  inventory:'INVENTORY', // 盘点
}

// 详情入库key-value
export const INTYPELIST = {
  [inTypeCode.order]: '订单入库', // 订单入库
  [inTypeCode.return]: '退货入库', // 退货入库
  [inTypeCode.transfer]: '调拨入库', // 调拨入库
  [inTypeCode.initial]: '期初建账', // 期初建账
  [inTypeCode.virtual]: '虚拟入库', // 虚拟入库
  [inTypeCode.other]: '其他入库', // 其他入库
}
// 详情出库key-value
export const OUTTYPELIST = {
  [outTypeCode.order]: '订单出库', // 订单出库
  [outTypeCode.return]: '退货出库', // 退货出库
  [outTypeCode.transfer]: '调拨出库', // 调拨出库
  [outTypeCode.transferBetween]: '调拨出库（库内）', // 调拨出库（库内）
  [outTypeCode.destruction]: '销毁出库', // 销毁出库
  [outTypeCode.other]: '其他出库', // 其他出库
}

// 是否越库枚举
export const OVERWAREHOUSE = [
  {
    value: '0',
    label: '否'
  },
  {
    value: '1',
    label: '是'
  }
]

// 仓操作项列表及默认值
export const WAREHOUSEACTIONS = {
  STORE: {
    defaultValue: ['存储', '入库', '分拣'],
    list: [
      {
        value: '存储',
        label: '存储',
        disabled: false,
      },
      {
        value: '入库',
        label: '入库',
        disabled: false,
      },
      {
        value: '处置',
        label: '处置',
        disabled: false,
      },
      {
        value: '打膜',
        label: '打膜',
        disabled: false,
      },
      {
        value: '贴标',
        label: '贴标',
        disabled: false,
      },
      {
        value: '销毁处置',
        label: '销毁处置',
        disabled: false,
      },
      {
        value: '单证',
        label: '单证',
        disabled: false,
      },
      {
        value: '装卸',
        label: '装卸',
        disabled: false,
      },
      {
        value: '分拣',
        label: '分拣',
        disabled: true,
      },
      {
        value: '拆零',
        label: '拆零',
        disabled: false,
      },
    ]
  },
  DELIVER: {
    defaultValue: ['分拣'],
    list: [
      {
        value: '处置',
        label: '处置',
        disabled: false,
      },
      {
        value: '打膜',
        label: '打膜',
        disabled: false,
      },
      {
        value: '贴标',
        label: '贴标',
        disabled: false,
      },
      {
        value: '销毁处置',
        label: '销毁处置',
        disabled: false,
      },
      {
        value: '单证',
        label: '单证',
        disabled: false,
      },
      {
        value: '装卸',
        label: '装卸',
        disabled: false,
      },
      {
        value: '分拣',
        label: '分拣',
        disabled: true,
      },
      {
        value: '拆零',
        label: '拆零',
        disabled: false,
      },
    ]
  }
}

export const BATCHLIST = [
  {
    value: 'box_no',
    label: '柜号'
  },
  {
    value: 'customer_batch',
    label: '客户批次'
  },
  {
    value: 'expire_date',
    label: '到期日期'
  },
  {
    value: 'inspectionQuearantineCode',
    label: '检验检疫文'
  },
  {
    value: 'productDate',
    label: '生产日期'
  },
  {
    value: 'store_date',
    label: '入库日期'
  },
  {
    value: 'store_no',
    label: '入库单号'
  },
  {
    value: 'traceCode',
    label: '追溯码'
  }
]

export const CarrierColumns = [
  {
    title: '送达司机姓名',
    dataIndex: 'driverName',
    key: 'driverName',
    width: 170,
    scopedSlots: { customRender: 'driverName' },
  },
  {
    title: '送达司机手机号',
    dataIndex: 'driverPhone',
    key: 'driverPhone',
    width: 170,
    scopedSlots: { customRender: 'driverPhone' },
  },
  {
    title: '车牌号',
    dataIndex: 'licensePlate',
    key: 'licensePlate',
    width: 170,
    scopedSlots: { customRender: 'licensePlate' },
  },
  {
    title: '车型',
    dataIndex: 'carTypeId',
    key: 'carTypeId',
    width: 240,
    scopedSlots: { customRender: 'carTypeId' },
  },
  {
    title: '车辆预估送货时间段',
    dataIndex: 'timeRange',
    key: 'timeRange',
    width: 240,
    scopedSlots: { customRender: 'timeRange' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed:'right',
    key: 'action',
    width: 120,
    scopedSlots: { customRender: 'action' },
  },
]

export const temperatureLayerOptions = [
  {
    label:'全部',
    value:'全部'
  },
  {
    label:'常温',
    value:'常温'
  },
  {
    label:'冷藏',
    value:'冷藏'
  },
  {
    label:'冷冻',
    value:'冷冻'
  }
]

// 盘点货品类型
export const inventoryType = [
  {
    value:'BY_GOODS',
    label:'货品'
  },
  {
    value:'BY_ZONES',
    label:'库区'
  }
]
